// extracted by mini-css-extract-plugin
module.exports = {"sizeSelector":"PenSizeSelector_sizeSelector__1Rtmj"};